<template>
    <section>
      <navigation  :activeTab='"players"'></navigation>

      <div v-if="leagueKey=='unknown'">
        <div class="mdl-grid center-items">
          <div class="mdl-cell mdl-cell--12-col center-items">
              <h5 style="text-align: center"><router-link to="/">Join or Create a league!</router-link></h5>
          </div>
        </div>
      </div>
      <div v-else-if="leagueKey!='noinit'">
        <div class="mdl-grid center-items">
          <div class="mdl-cell mdl-cell--12-col center-items">
            <AddPlayerModal />
          </div>
          <div class="mdl-cell mdl-cell--12-col center-items">
            <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--6-col center-items">
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
                	<select class="mdl-textfield__input form-control" v-model="weekSelected" :required="true">
        	          <option :selected="true" value="season">Season</option>
        	          <option v-for="w of weeks" v-bind:value="w['.key']">Week {{ w['.value'] }}</option>
                    <option value="season2020">2020 Season</option>
        	        </select>
        	        <label class="mdl-textfield__label" for="viewStatsSelect">View Stats By</label>
        	      </div>
              </div>
              <div class="mdl-cell mdl-cell--6-col center-items">
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
                  <select class="mdl-textfield__input form-control" v-model="viewByPosition" :required="true">
                    <option :selected="true" value="true">By Position</option>
                    <option value="false">Best Available</option>
                  </select>
                  <label class="mdl-textfield__label" for="viewStatsGroup">Group Players</label>
                </div>
              </div>
            </div>

            <div v-if="viewByPosition=='true'">
              <h5 class="center-align" id="outfieldTable">Top Available Outfielders</h5>
              <p class="center-align">Jump to: &nbsp; <a href="#outfieldTable">OF</a> &nbsp; <a href="#dhTable">DH</a> &nbsp; <a href="#firstTable">1B</a> &nbsp; <a href="#secondTable">2B</a> &nbsp; <a href="#thirdTable">3B</a> &nbsp; <a href="#shortTable">SS</a> &nbsp; <a href="#catcherTable">C</a> &nbsp; <a href="#pitchersTable">P</a></p>
              <BatterTable tableName="outfield" pos="OF" :weekKey=weekSelected :batters="batters"  :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>

              <h5 class="center-align" id="dhTable">Top Available DH</h5>
              <p class="center-align">Jump to: &nbsp; <a href="#outfieldTable">OF</a> &nbsp; <a href="#dhTable">DH</a> &nbsp; <a href="#firstTable">1B</a> &nbsp; <a href="#secondTable">2B</a> &nbsp; <a href="#thirdTable">3B</a> &nbsp; <a href="#shortTable">SS</a> &nbsp; <a href="#catcherTable">C</a> &nbsp; <a href="#pitchersTable">P</a></p>
              <BatterTable tableName="dhtable" pos="DH" :batters="batters" :weekKey=weekSelected :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>

              <h5 class="center-align" id="firstTable">Top Available First Basemen</h5>
              <p class="center-align">Jump to: &nbsp; <a href="#outfieldTable">OF</a> &nbsp; <a href="#dhTable">DH</a> &nbsp; <a href="#firstTable">1B</a> &nbsp; <a href="#secondTable">2B</a> &nbsp; <a href="#thirdTable">3B</a> &nbsp; <a href="#shortTable">SS</a> &nbsp; <a href="#catcherTable">C</a> &nbsp; <a href="#pitchersTable">P</a></p>
              <BatterTable tableName="firsttable" pos="1B" :batters="batters" :weekKey=weekSelected :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>

              <h5 class="center-align" id="secondTable">Top Available Second Basemen</h5>
              <p class="center-align">Jump to: &nbsp; <a href="#outfieldTable">OF</a> &nbsp; <a href="#dhTable">DH</a> &nbsp; <a href="#firstTable">1B</a> &nbsp; <a href="#secondTable">2B</a> &nbsp; <a href="#thirdTable">3B</a> &nbsp; <a href="#shortTable">SS</a> &nbsp; <a href="#catcherTable">C</a> &nbsp; <a href="#pitchersTable">P</a></p>
              <BatterTable tableName="secondtable" pos="2B" :batters="batters" :weekKey=weekSelected :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>

              <h5 class="center-align" id="thirdTable">Top Available Third Basemen</h5>
              <p class="center-align">Jump to: &nbsp; <a href="#outfieldTable">OF</a> &nbsp; <a href="#dhTable">DH</a> &nbsp; <a href="#firstTable">1B</a> &nbsp; <a href="#secondTable">2B</a> &nbsp; <a href="#thirdTable">3B</a> &nbsp; <a href="#shortTable">SS</a> &nbsp; <a href="#catcherTable">C</a> &nbsp; <a href="#pitchersTable">P</a></p>
              <BatterTable tableName="thirdtable" pos="3B" :batters="batters" :weekKey=weekSelected :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>

              <h5 class="center-align" id="shortTable">Top Available Shortstops</h5>
              <p class="center-align">Jump to: &nbsp; <a href="#outfieldTable">OF</a> &nbsp; <a href="#dhTable">DH</a> &nbsp; <a href="#firstTable">1B</a> &nbsp; <a href="#secondTable">2B</a> &nbsp; <a href="#thirdTable">3B</a> &nbsp; <a href="#shortTable">SS</a> &nbsp; <a href="#catcherTable">C</a> &nbsp; <a href="#pitchersTable">P</a></p>
              <BatterTable tableName="shorttable" pos="SS" :batters="batters" :weekKey=weekSelected :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>

              <h5 class="center-align" id="catcherTable">Top Available Catchers</h5>
              <p class="center-align">Jump to: &nbsp; <a href="#outfieldTable">OF</a> &nbsp; <a href="#dhTable">DH</a> &nbsp; <a href="#firstTable">1B</a> &nbsp; <a href="#secondTable">2B</a> &nbsp; <a href="#thirdTable">3B</a> &nbsp; <a href="#shortTable">SS</a> &nbsp; <a href="#catcherTable">C</a> &nbsp; <a href="#pitchersTable">P</a></p>
              <BatterTable tableName="catchertable" pos="C" :batters="batters" :weekKey=weekSelected :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>
            </div>

            <div v-else>
              <h5 class="center-align"  id="battersTable">Top Available Batters</h5>
              <p class="center-align">Jump to: &nbsp; <a href="#battersTable">Batters</a> &nbsp; <a href="#pitchersTable">Pitchers</a></p>
              <BatterTable tableName="allbatters" pos="All" :weekKey=weekSelected :batters="batters"  :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>
            </div>

            <h5 class="center-align" id="pitchersTable">Top Available Pitchers</h5>
            <div v-if="viewByPosition=='true'">
              <p class="center-align">Jump to: &nbsp; <a href="#outfieldTable">OF</a> &nbsp; <a href="#dhTable">DH</a> &nbsp; <a href="#firstTable">1B</a> &nbsp; <a href="#secondTable">2B</a> &nbsp; <a href="#thirdTable">3B</a> &nbsp; <a href="#shortTable">SS</a> &nbsp; <a href="#catcherTable">C</a> &nbsp; <a href="#pitchersTable">P</a></p>
            </div>
            <div v-else>
              <p class="center-align">Jump to: &nbsp; <a href="#battersTable">Batters</a> &nbsp; <a href="#pitchersTable">Pitchers</a></p>
            </div>
            <PitcherTable tableName="pitchers" :pitchers="pitchers" :weekKey=weekSelected :leagueKey="leagueKey" :teamKey="teamKey" :leagueStatus="leagueStatus" :userUID="userUID"/>

          </div>
        </div>
      </div>
    </section>
</template>

<script>

// RecentDocuments.vue
import navigation from "@/components/NavBar.vue";
import BatterTable from "@/components/BatterTable.vue";
import PitcherTable from "@/components/PitcherTable.vue";
 import AddPlayerModal from "@/components/AddPlayerModal.vue";
import { db } from '../db'
import firebase from "firebase";

export default {
  data() {
    return {
      batters: [],
      pitchers: [],
      weeks: [],
      weekSelected: "season",
      leagueKey: "noinit",
      teamKey: null,
      user: null,
      leagueInfo: null,
      viewByPosition:"true",
    }
  },
  computed: {
    leagueStatus() {
      if (this.leagueInfo){
        return this.leagueInfo.status
      }
      return "locked"
    },
    userUID(){
      if (this.user){
        return this.user.uid
      }
      return "nouser"
    }
  },
  components: {
    navigation,
    BatterTable,
    PitcherTable,
    AddPlayerModal
  },
  firebase: {
    batters: db.ref('batters/players/').orderByChild("hits"),
    pitchers: db.ref('pitchers/players/').orderByChild("ip"),
    weeks: db.ref('weeks2021/'),
  },
  created() {
    firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
            this.user = user;
            let tmp = "unknown"
            let tmp2 = this.teamKey
            await db.ref('users/'+user.uid+'/leagues/').once('value',function(snapshot){
            	snapshot.forEach(function(childSnapshot){
            		tmp = childSnapshot.val().leagueUID
                tmp2 = childSnapshot.val().teamUID
            	})
            })
        	this.leagueKey = tmp
          this.teamKey = tmp2
            
            
        }
    });
  },
  watch: {
    leagueKey: {
      // call it upon creation too
      immediate: true,
      handler(leagueKey) {
        this.$rtdbBind('leagueInfo', db.ref('leagues').child(leagueKey))
      },
    },
  },
}




</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Players.vue